export namespace QuestionIndexing {
  export interface TrQiLiteQuestion {
    id: number;
    course: {
      id: number;
      name: string;
      slug: string;
    };
    subject: {
      id: number;
      name: string;
      slug: string;
      remote_id?: number;
    };
    slug: string;

    question_image: string;
    seo_title: string;
    content: string;
  }
  export interface TrQiQuestion extends TrQiLiteQuestion {
    title: string;
    answer_image: string;
    raw_answer_image: string;
    seo_meta: string;
    branch_io_link: string;
    question: number;
    structured_data: {
      acceptedAnswer?: {
        author?: string;
        dateCreated?: string;
        text?: string;
        url?: string;
      };
      answerCount?: number;
      author?: string;
      dateCreated?: string;
      name?: string;
      text?: string;
    };
    status: TrQiQuestionStatus;
    is_edited: boolean;
    modified_at?: string;
  }
  export interface UsQiLiteQuestion {
    id: number;
    course_name: string;
    subject_name: string;
    course_id: number;
    subject_id: number;
    slug: string;
    question_image: string;
    header: string;
    text: string;
  }
  export interface UsQiQuestion {
    id: number;
    question_id: number;
    course: string;
    subject: string;
    text_content: string;
    header: string;
    seo_title: string;
    seo_meta: string;
    subject_id: number;
    image: string;
    course_id: number;
    answer_image: string;
    branch_io_link?: string;
    slug: string;
    modified_at?: string;
    is_deleted?: boolean;
  }
  export enum TrQiQuestionStatus {
    LISTED = 1,
    REMOVED = 2,
    UNLISTED = 3,
  }
  export interface IQiCourse {
    icon_v2: string;
    logo: string;
    id: number;
    name: string;
    subjects: IQiSubject[];
    slug: string;
    meta: {
      color: string;
      display_name: string;
      grades: number[];
      seo: {
        long_text?: string;
        short_text?: string;
        description_for_premium_content?: string;
        long_text_for_premium_content?: string;
        short_text_for_premium_content?: string;
        seo_subject_ids: number[];
      };
      show_on_today: boolean;
    };
    seo_subjects: any[];
    has_question_seo: boolean;
    num_subjects?: number;
    num_video_contents?: number;
  }
  export interface IQiSubject {
    id: number;
    name: string;
    slug: any;
    remote_id: number;
    meta: {
      description_for_premium_content?: string;
      title_for_premium_content?: string;
      seo: {
        long_text: string;
        short_text: string;
      };
    };
    has_question_seo: boolean;
  }
}
